import React from 'react';

import styles from './Button.module.scss';


const ELEM_STYLE = {
  'next': styles.Next,
};

const Button = (props) => {
  const { bClass, bStyle, elemStyle, onClick } = props;
  const buttonClasses = [styles.Button];

  if (ELEM_STYLE.hasOwnProperty(elemStyle)) buttonClasses.push(ELEM_STYLE[elemStyle]);
  if (bClass) buttonClasses.push(bClass);

  return (
    <button className={buttonClasses.join(' ')}
        style={bStyle}
        onClick={onClick}>
      {props.children}
    </button>
  );
};

Button.defaultProps = {
  bClass: undefined,
  bStyle: undefined,
  elemStyle: undefined,
};

export default Button;
